import React from 'react';
import cs from 'classnames';
import isEmpty from 'lodash/isEmpty';
import upperFirst from 'lodash/upperFirst';

import css from './index.css';

const statusMatch = {
  not_paid: 'Pending',
  failed_paid: 'Failed',
  success_paid: 'Paid',
  expired: 'Expired',
};

class Chart extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className={cs(css.chartWrap, css.addLeftLine, css.addTopLine)}>
        <div className={cs(css.titleWrap, css.addBottomLine)}>
          {this.props.chartHeader.map((item, index) => {
            if (index === 1) {
              return (<div key={index} className={cs(css.flex2, css.addRightLine, css.chartTd)}>{item}</div>);
            }
            return (<div key={index} className={cs(css.flex1, css.addRightLine, css.chartTd)}>{item}</div>);
          })}
        </div>
        <div className={cs(css.bodyWrap)}>
          {this.renderChartBody()}
        </div>
      </div>
    );
  }

  renderChartBody() {
    const chartData = this.props.chartData;
    if (chartData.loading) {
      return (
        <div className={cs(css.chartItemWrap, css.addBottomLine, css.addRightLine)}>loading...</div>
      );
    }
    if (chartData.error) {
      return (
        <div className={cs(css.chartItemWrap, css.addBottomLine, css.addRightLine)}>No Data</div>);
      // return (
      //   <div className={cs(css.chartItemWrap, css.addBottomLine, css.addRightLine)}
      //     onClick={this.props.fn}
      //   >{chartData.error}</div>);
    }
    if (chartData.data && Array.isArray(chartData.data) && chartData.data.length) {
      return chartData.data.map((item, index) => {
        const description = item.description ? item.description.replace(new RegExp("\\n", "g"), '<br/>'): ' ';
        let bigChart = item.description.includes('first year at') || item.description.includes('ELD Bundle') ? true : false;
        return (
          < div className = {
            cs(css.chartItemWrap, css.addBottomLine, bigChart && css.chartItemWrapBig)
          }
            key={index}
          >
            <div className={cs(css.flex1, css.addRightLine, css.chartTd)}>
              {item.date || item.next_billing_date ? item.date || item.next_billing_date : ' '}
            </div>
            <div className={cs(css.flex2, css.addRightLine, css.chartTd)}>
              <p className={css.desStyle} dangerouslySetInnerHTML={{__html: description}} />
            </div>
            <div className={cs(css.flex1, css.addRightLine, css.chartTd)}>
              {item.amount ? item.amount : 0}
            </div>
            <div className={cs(css.flex1, css.addRightLine, css.chartTd)}>
              {!item.status && ''}
              {item.status && statusMatch[item.status] ? statusMatch[item.status] : upperFirst(item.status)}
            </div>
          </div>);
      }
      );
    }
    if (chartData.data && (chartData.data instanceof Object) && !isEmpty(chartData.data)) {
      const description = chartData.data.description ? chartData.data.description.replace(new RegExp("\\n", "g"), '<br/>') : ' ';
      let bigChart = chartData.data.product.pay_option.discount_price !== chartData.data.product.pay_option.origin_price ? true : false

      return (
        <div className={cs(css.chartItemWrap, css.addBottomLine, bigChart && css.chartItemWrapBig)}>
          <div className={cs(css.flex1, css.addRightLine, css.chartTd)}>
            {chartData.data.next_billing_date ? chartData.data.next_billing_date : ' '}
          </div>
          <div className={cs(css.flex2, css.addRightLine, css.chartTd)}>
            <p className={css.desStyle} dangerouslySetInnerHTML={{__html: description}} />
          </div>
          <div className={cs(css.flex1, css.addRightLine, css.chartTd)}>
            {chartData.data.amount ? chartData.data.amount : 0}
          </div>
          <div className={cs(css.flex1, css.addRightLine, css.chartTd)}>
            {!chartData.data.status && ' '}
            {(chartData.data.status && statusMatch[chartData.data.status])
              ? statusMatch[chartData.data.status]
              : chartData.data.status
            }
          </div>
        </div>);
    }
    return (
      <div className={cs(css.chartItemWrap, css.addBottomLine, css.addRightLine)}>No Data</div>
    );
  }
}
export default Chart;



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/Chart/index.js